import { CloseIcon, DeleteIcon, EditIcon } from "@chakra-ui/icons";
import { Box, HStack, IconButton, Stack, Text } from "@chakra-ui/react";
import { Category, Cue } from "../../utils/vtt";
import CategoryItem from "./CategoryItem";
import { useTranslation } from "react-i18next";

type Props = {
  cue: Cue;
  category?: Category;
  index: number;
  onEdit: () => void;
  onDelete: () => void;
  leaveEdit: () => void;
  onClick: () => void;
  isSelected?: boolean;
  isDisabled?: boolean;
};

export default function CueItem({
  cue,
  category,
  index,
  onEdit,
  onDelete,
  onClick,
  isSelected,
  leaveEdit,
  isDisabled = false,
}: Props) {
  const { t } = useTranslation();

  return (
    <Stack
      flexDirection="row"
      padding={4}
      bg={isSelected ? "orange.100" : "transparent"}
    >
      <HStack flexGrow={1}>
        <Box paddingX={4}>
          <Text fontSize="lg">#{index}</Text>
        </Box>
        <HStack flexGrow={1} gap={4} justifyContent="space-between">
          <Stack cursor="pointer" onClick={onClick}>
            <HStack>
              <Text fontSize="md" style={{ textDecoration: "underline" }}>
                {t("common.labels.start")}: {cue.startTime} -{" "}
                {t("common.labels.end")}: {cue.endTime}
              </Text>
              {category && <CategoryItem category={category} />}
            </HStack>
            {cue.text.split("\n").map((text, index) => (
              <Text lineHeight={1} key={`${text}${index}`} fontSize="md">
                {text}
              </Text>
            ))}
            <Text fontStyle="italic" fontSize={13}>
              {cue.type === "captions"
                ? t("common.labels.caption")
                : t("common.labels.subtitle")}
            </Text>
          </Stack>
          {!isDisabled && (
            <HStack gap={2}>
              <IconButton
                onClick={isSelected ? leaveEdit : onEdit}
                aria-label={isSelected ? "Leave cue" : "Edit cue"}
                icon={isSelected ? <CloseIcon /> : <EditIcon />}
              />
              <IconButton
                bg="red.100"
                color="primary.DEFAULT"
                onClick={onDelete}
                aria-label="Delete cue"
                icon={<DeleteIcon />}
              />
            </HStack>
          )}
        </HStack>
      </HStack>
    </Stack>
  );
}
